function openCheckout(self) {
  self.el.addEventListener('click', function() {
    let {csr, publicKey, name, description} = self.el.dataset
    SecurionpayCheckout.key = publicKey;
    SecurionpayCheckout.success = function (result) {
      self.pushEvent("close_show_offers", {}, () => {} )
    };

    SecurionpayCheckout.error = function (errorMessage) {
      console.log(errorMessage)
    };

    SecurionpayCheckout.close = function (errorMessage) {
      self.pushEvent("close_show_offers", {}, () => {} )
    };

    SecurionpayCheckout.open({
      checkoutRequest: csr,
      name: name,
      description: description
    });

  })
}

const OpenCheckout = {
  mounted() {
    openCheckout(this)
  },
}

const PaymentList = {
  mounted(){
    this.handleEvent("submit_form", (data) => {
      let form = document.getElementById(data.form_id)
      form.submit()
    })
  },
}

const AutoSubmitForm = {
  mounted() {
    let form = this.el.querySelector('form')
    form.submit()
  }
}

const LinkInNewTab = {
  mounted() {
    let offerId = this.el.dataset["offerId"]
    let processor = this.el.dataset["processor"]
    this.el.addEventListener('click', () => {
      let l = this.pushEvent("generate_invoice", {offer_id: offerId, processor: processor})
      this.windowHandler = window.open('', '_blank');
    })
    this.handleEvent("open_link_in_tab", (p) => {
      this.windowHandler.location.replace(p.url)
    })
  }
}

const CCBillPayment = {
  mounted() {
    this.el.addEventListener('click', (event) => {
      event.preventDefault()
      if (this.submitting) return

      this.submitting = true
      this.el.disabled = true

      let form = document.getElementById(this.el.getAttribute('form'))
      let windowName = `ccbill-payment-${Date.now()}`
      let paymentWindow = window.open('', windowName)

      form.target = paymentWindow && !paymentWindow.closed ? windowName : '_self'
      form.submit()
    })
  }
}

export default { OpenCheckout, PaymentList, AutoSubmitForm, LinkInNewTab, CCBillPayment };
